import { Component } from '@angular/core';
import { assetsConst } from 'src/app/core/const/assets.const';
export interface PeriodicElement {
  position: number;
  image: string;
  name: string;
  category: string;

  action: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {
    position: 1,
    image: '123',
    name:'Toy Car',
    category: 'Toys',


    action: ''
  },
  {
    position: 2,
    image: '123',
    name:'Toy Car',
    category: 'Toys',


    action: ''
  },
  {
    position: 3,
    image: '123',
    name:'Toy Car',
    category: 'Toys',


    action: ''
  }
  
];
@Component({
  selector: 'mega-store-factory-add-product-list',
  templateUrl: './add-product-list.component.html',
  styleUrls: ['./add-product-list.component.scss']
})
export class AddProductListComponent {
  assetsConst = assetsConst;

  displayedColumns: string[] = [
    'position',
    'image',
    'name',
  
    'category',
  
    'action'
  ];
  dataSource = ELEMENT_DATA;
}
